<mat-menu>
  @if (hasBrowser) {
    <button
      (click)="openInBrowser.emit()"
      [disabled]="!hasManifest"
      id="catalog_header_btn_open-detail-in-browser"
      mat-menu-item
    >
      <mat-icon>eyeglasses</mat-icon>
      <span>{{ 'catalog.detail.actions.view_in_browser' | transloco }}</span>
    </button>
  }

  @if (hasBrowser) {
    <mat-divider></mat-divider>
  }

  <button (click)="copyUrl.emit()" id="catalog_header_btn_copy-detail-url" mat-menu-item>
    <mat-icon>content_copy</mat-icon>
    <span>{{ 'catalog.detail.actions.copy_url' | transloco }}</span>
  </button>

  @if (overlayEnabled) {
    <button (click)="openOverlay.emit()" id="catalog_header_btn_open-overlay" mat-menu-item>
      <mat-icon>crop_square</mat-icon>
      <span>{{ 'catalog.detail.actions.open_overlay' | transloco }}</span>
    </button>
  }

  @if (enablePin) {
    <button (click)="pin.emit()" id="catalog_header_btn_pin-detail" mat-menu-item>
      <mat-icon>keep</mat-icon>
      <span>{{ 'catalog.detail.actions.pin' | transloco }}</span>
    </button>
  }

  <button (click)="compare.emit()" id="catalog_header_btn_open-compare-dialog" mat-menu-item>
    <mat-icon>text_compare</mat-icon>
    <span>{{ 'catalog.detail.actions.compare' | transloco }}</span>
  </button>

  @if (enableFullscreen) {
    <mat-divider></mat-divider>
  }

  @if (enableFullscreen) {
    <button
      (click)="fullscreen.emit()"
      id="catalog_header_btn_toggle-detail-fullscreen"
      mat-menu-item
    >
      <mat-icon>{{ isFullscreen ? 'close_fullscreen' : 'fullscreen' }}</mat-icon>
      <span>{{ (isFullscreen ? 'catalog.header.minimize' : 'catalog.header.maximize') | transloco }}</span>
    </button>
  }
</mat-menu>
